import intl from "react-intl-universal";
import { TbCalendar, TbCurrencyReal, TbSwitchHorizontal } from "react-icons/tb";
import { ModernFilterBar } from "../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  CheckboxListFilterPanel,
  DateFilterPanel,
  MoreFiltersAmountSection,
  MoreFiltersCheckboxSection,
  MoreFiltersDateSection,
} from "../../../../Components/Molecules/Filters/ModernFilterPanels";
import { getCiPaymentMethodOptions } from "../contaInternacionalHistoryFilters";
import {
  EMPTY_MOVEMENT_FILTERS,
  buildMovementFilterTags,
  exportMovementsCsv,
  getMovementKindOptions,
  getMovementStatusOptions,
  hasActiveMovementFilters,
  isMovementChipFilterActive,
  removeMovementFilterTag,
} from "../contaInternacionalMovementFilters";

const MovementMoreFiltersForm = ({ draft, onChange }) => {
  const statuses = getMovementStatusOptions();
  const paymentMethods = getCiPaymentMethodOptions();

  return (
    <div className="extract-more-filters-form">
      <MoreFiltersDateSection draft={draft} onChange={onChange} />
      <MoreFiltersAmountSection
        draft={draft}
        onChange={onChange}
        idPrefix="movement-more"
        minLabelKey="contaInternacional.amountMin"
        maxLabelKey="contaInternacional.amountMax"
      />
      <MoreFiltersCheckboxSection
        label={intl.get("grid.status")}
        options={statuses}
        selectedValues={draft.statuses}
        onChange={(statuses) => onChange({ ...draft, statuses })}
        idPrefix="movement-more-status"
      />
      <MoreFiltersCheckboxSection
        label={intl.get("contaInternacional.filterPaymentMethod")}
        options={paymentMethods}
        selectedValues={draft.paymentMethods}
        onChange={(paymentMethods) => onChange({ ...draft, paymentMethods })}
        idPrefix="movement-more-payment"
      />
    </div>
  );
};

export const MovementFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
  currencyId,
}) => {
  const typeOptions = getMovementKindOptions();

  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isMovementChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isMovementChipFilterActive(filters, "amount"),
    },
    {
      id: "type",
      icon: TbSwitchHorizontal,
      label: intl.get("contaInternacional.filterType"),
      active: isMovementChipFilterActive(filters, "type"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return (
          <AmountFilterPanel
            draft={draft}
            onChange={onChange}
            idPrefix="movement-filter"
            minLabelKey="contaInternacional.amountMin"
            maxLabelKey="contaInternacional.amountMax"
          />
        );
      case "type":
        return (
          <CheckboxListFilterPanel
            options={typeOptions}
            selectedValues={draft.kinds}
            onChange={(kinds) => onChange({ ...draft, kinds })}
            idPrefix="movement-type"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_MOVEMENT_FILTERS}
      searchPlaceholder={intl.get("extract.searchTransaction")}
      filterButtons={filterButtons}
      moreFiltersActive={isMovementChipFilterActive(filters, "more")}
      buildFilterTags={buildMovementFilterTags}
      hasActiveFilters={hasActiveMovementFilters}
      removeFilterTag={removeMovementFilterTag}
      onExport={(items) => exportMovementsCsv(items, currencyId)}
      filteredItems={filteredItems}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <MovementMoreFiltersForm draft={draft} onChange={onChange} />
      )}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
        type: intl.get("contaInternacional.filterType"),
      }}
    />
  );
};
